import {
  IonContent,
  IonPage,
  IonRouterOutlet,
  IonSearchbar,
} from '@ionic/react';
import React from 'react';
import { dashboardPageStyle } from '../../Layout';
import PageTitle from '../../../../components/Dashboard/PageTitle';
import ChatButton, {
  ChatButtonSkeleton,
} from '../../../../components/Dashboard/chat/ChatButton';
import { Redirect, Route, RouteComponentProps } from 'react-router';
import ChatRoom from './Pages/ChatRoom';
import clsx from 'clsx';
import EmptyPage from '../../../../components/ui/EmptyPage';
import { useConversations } from '../../../../services/messaging/hooks/useConversations';
import ErrorBanner from '../../../../components/ui/ErrorBanner';

const skeletonConversations = new Array(5).fill(0);
export default function index({ match }: RouteComponentProps) {
  const [showChat, setShowChat] = React.useState(false);
  const { conversations, isLoading, refetch, isError, error } =
    useConversations();

  // STYLE FOR CHAT NAV
  const chatNavStyle = clsx(
    'bg-background pb-4 h-full overflow-y-hidden sm:rounded-md sm:border sm:border-border',
    'max-sm:absolute relative',
    'max-sm:z-30',
    'min-h-full w-full sm:w-[40%]'
  );

  // STYLE FOR CHAT AREA
  const chatAreaStyle = clsx(
    'min-h-full bg-background flex-1 relative transition-all duration-300',
    'max-sm:absolute',
    'max-sm:z-50 sm:translate-x-0',
    !showChat ? 'translate-x-full' : 'translate-x-0',
    'min-h-full w-full'
  );

  return (
    <IonPage>
      <IonContent>
        <div className={`${dashboardPageStyle} flex flex-col h-full w-full`}>
          <PageTitle>Chat</PageTitle>
          <div className="max-sm:relative flex-1 sm:flex sm:items-stretch gap-6 overflow-hidden">
            <div className={chatNavStyle}>
              <div className="flex flex-col h-full">
                <div className="flex items-center gap-2 sm:pt-4 pb-2 sm:px-2">
                  {/* {(conversations && conversations?.length < 1) && (<IonicButton className=' button-with-icon'>
                      <IonIcon icon={addOutline} />
                      <span>
                        Create chat
                      </span>
                    </IonicButton>)} */}
                  <div className=" flex-1 bg-background ">
                    <IonSearchbar
                      disabled={!conversations || conversations?.length < 1}
                      placeholder="Search name, chat. e.t.c"
                      style={{
                        '--box-shadow': 'none',
                        '--background': 'transparent',
                      }}
                      className="p-0 h-full bg-gray-50 rounded-md min-h-9 text-sm font-dm_sans border border-border font-light text-text-dark-high"
                    />
                  </div>
                </div>
                <div className="flex-1 overflow-y-auto px-2 dashboard-scroller overflow-x-hidden">
                  {/* ACTIVE CHATS NAV */}
                  <div className="space-y-2">
                    {isError && (
                      <ErrorBanner
                        buttonLabel="retry"
                        message={error.message}
                        retry={refetch}
                      />
                    )}
                    {conversations &&
                      conversations.map((chat) => (
                        <ChatButton
                          {...chat}
                          key={`conversation-${chat.id}`}
                          onClick={() => {
                            refetch();
                            setShowChat(true);
                          }}
                        />
                      ))}

                    {isLoading &&
                      skeletonConversations.map((_, index) => (
                        <ChatButtonSkeleton
                          key={`dummy-conversation-${index}`}
                        />
                      ))}
                  </div>
                </div>
              </div>
            </div>
            <div className={chatAreaStyle}>
              {conversations && conversations.length > 0 ? (
                <IonRouterOutlet>
                  <Redirect
                    from="/dashboard/chat"
                    to={`${match.path}/${conversations && conversations[0].id}`}
                    exact
                  />
                  <Route
                    path={`${match.path}/:id`}
                    render={() => (
                      <ChatRoom
                        onBack={() => {
                          setShowChat(false);
                        }}
                      />
                    )}
                  />
                </IonRouterOutlet>
              ) : (
                <EmptyPage message="No conversation yet" className="h-full" />
              )}
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
